<template>
    <v-dialog v-model="dialog" max-width="80%">
        <v-card>
            <v-card-title>
                Order Details & Readings
                <v-spacer></v-spacer>
                <v-btn icon @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-expansion-panels v-model="orderDetailsPanel">
                    <v-expansion-panel
                        v-for="(orderDetail, orderDetailIndex) in orderDetails"
                        :key="orderDetailIndex"
                    >
                        <v-expansion-panel-header>
                            Order Detail #{{ orderDetailIndex + 1 }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <!-- Chips for Dispatched and Delivered Quantities -->
                            <v-chip
                                label
                                color="info"
                                outlined
                                small
                                class="my-1 mr-1"
                            >
                                Dispatched quantity:
                                <b>{{ orderDetail.DispatchedQuantity }}</b>
                            </v-chip>
                            <v-chip
                                label
                                color="info"
                                outlined
                                small
                                class="my-1 mr-1"
                            >
                                Delivered quantity:
                                <b>{{ orderDetail.DeliveredQuantity }}</b>
                            </v-chip>

                            <v-divider></v-divider>

                            <!-- Safe Fill and Pump -->
                            <v-chip
                                label
                                color="info"
                                outlined
                                small
                                class="my-1 mr-1"
                            >
                                Safe Fill:
                                <b>{{
                                    orderDetail.productDetails.total_safe_fill
                                }}</b>
                            </v-chip>
                            <v-chip
                                label
                                color="info"
                                outlined
                                small
                                class="my-1 mr-1"
                            >
                                Safe Pump:
                                <b>{{
                                    orderDetail.productDetails.total_safe_pump
                                }}</b>
                            </v-chip>

                            <v-divider></v-divider>

                            <!-- Average Consumption -->
                            <div>
                                Daily average consumption:
                                {{
                                    getAverageConsumption(
                                        null,
                                        orderDetail.averageConsumptions,
                                        'daily'
                                    )
                                }}
                            </div>

                            <v-divider></v-divider>

                            <!-- Data Table for Readings -->
                            <v-data-table
                                :headers="filteredReadingsHeaders"
                                :items="orderDetail.readings"
                                :items-per-page="-1"
                                fixed-header
                                height="50vh"
                            >
                                <template #top>
                                    <v-toolbar
                                        dark
                                        flat
                                        dense
                                        :color="moduleColor"
                                    >
                                        <v-toolbar-title class="text-uppercase">
                                            Readings
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            dark
                                            plain
                                            small
                                            @click="
                                                showConsumptionColumns = !showConsumptionColumns
                                            "
                                        >
                                            {{
                                                showConsumptionColumns
                                                    ? 'Hide'
                                                    : 'Show'
                                            }}
                                            Consumption Columns
                                        </v-btn>
                                    </v-toolbar>
                                </template>
                                <!-- Your existing templates for table items go here -->
                            </v-data-table>

                            <v-divider></v-divider>

                            <!-- Expansion panel for Forecast rundown -->
                            <v-expansion-panels
                                v-model="orderDetailRundownPanel"
                            >
                                <v-expansion-panel>
                                    <v-expansion-panel-header>
                                        Forecast rundown
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-data-table
                                            :headers="rundownHeaders"
                                            :items="
                                                orderDetail.rundown
                                                    .simulation_data
                                            "
                                            :items-per-page="-1"
                                            fixed-header
                                            height="50vh"
                                        >
                                            <template
                                                #item.forecasted_volume="{ item }"
                                            >
                                                {{
                                                    item.forecasted_volume.toFixed(
                                                        0
                                                    )
                                                }}
                                            </template>
                                        </v-data-table>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'OrderDetailsDialog',
    props: {
        dialog: {
            type: Boolean,
            required: true
        },
        orderDetails: {
            type: Array,
            required: true
        },
        moduleColor: {
            type: String,
            default: 'purple'
        }
    },
    data() {
        return {
            orderDetailsPanel: 0,
            orderDetailRundownPanel: null,
            showConsumptionColumns: true,
            filteredReadingsHeaders: [], // Populate this with the necessary headers
            rundownHeaders: [] // Populate this with the necessary headers
        };
    },
    methods: {
        closeDialog() {
            this.$emit('update:dialog', false);
        },
        getAverageConsumption() {}
        // Add your existing methods for data handling here
    }
};
</script>
